<template>
  <div>
    <template v-for="(route, index) in routes">
      <el-menu-item
        v-if="$utils.isEmpty(route.children)"
        :key="route.title + index"
        :index="route.path"
        class="single-item"
      >
        <span class="menu-text">
          <span :class="['iconfont', route.meta.icon, 'menu-icon']"></span>
          <el-badge is-dot class="item" :hidden="!route.alert">{{ route.meta.title }}</el-badge>
        </span>
      </el-menu-item>
      <el-submenu v-else :key="route.title + index + route.path" :index="route.title">
        <template slot="title">
          <span class="menu-text">
            <span :class="['iconfont', route.meta.icon, 'menu-icon']"></span>
            {{ route.title }}
          </span>
        </template>
        <menu-item :routes="route.children"></menu-item>
      </el-submenu>
    </template>
  </div>
</template>
<script>
export default {
  name: 'MenuItem',
  props: {
    routes: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>
